export default __webpack_public_path__ + "static/media/kitchen3-before1-1024w.633ad550.avif";